import { format } from 'date-fns'
import { useEffect, useRef, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { delProductQna, getMyProductQna } from '../../api/productQna'
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar'
import { useAppContext } from '../../components/provider/AppProvider'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/myshopping.css'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'

// 이미지 경로
const imgURL = '/images'

export default function ProductQnaList() {
  const [drop, setDrop] = useState<number | null>(null)
  const [page, setPage] = useState<number>(1)
  const [qnaData, setQnaData] = useState<any>(null)
  const { isAppView } = useAppContext()
  const { setIsLottie } = useCommonContext()
  const navigate = useNavigate()

  const editDropPopRef = useRef<any>(null)
  const btnDropPopRef = useRef<any>(null)

  useEffect(() => {
    const handleClickOutside = (e: any) => {
      if (
        editDropPopRef.current &&
        !editDropPopRef.current.contains(e.target) &&
        btnDropPopRef.current &&
        !btnDropPopRef.current.contains(e.target)
      ) {
        setDrop(null)
      }
    }
    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [editDropPopRef, btnDropPopRef])

  const fetchData = () => {
    getMyProductQna({ pageNumber: page, pageSize: 999 })
      .then((res) => {
        setQnaData(res)
        setIsLottie(false)
      })
      .catch((err) => console.log(err))
  }

  useEffect(() => {
    fetchData()
  }, [])

  //  상품문의가 없을 때 박스 높이 조절
  useEffect(() => {
    const contentsWrap = document.querySelector('.contents_wrap') as HTMLElement

    qnaData?.data.items.length === 0 ? contentsWrap?.classList.add('full') : contentsWrap?.classList.remove('full')
  }, [qnaData])

  return (
    <>
      <div className='main_wrap'>
        <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap'}>
          <MyShoppingSideBar />
          <div className='myshopping_wrap'>
            <PageTitle>상품 Q&A</PageTitle>
            {qnaData !== null && qnaData.data.items.length > 0 ? (
              <>
                {qnaData.data.items.map((el: any, index: number) => (
                  <QnaList key={index}>
                    <div className='qna_item'>
                      <div className='q_box'>
                        <div className='head'>
                          <div className='inner_head'>
                            <span style={{ color: el.replied && '#191919' }}>
                              {el.replied ? '답변완료' : '답변대기'}
                            </span>

                            <i></i>
                            <em>
                              {((): any => {
                                const date = new Date(el.registerYmdt)
                                return format(date, 'yyyy. M. d')
                              })()}
                            </em>
                          </div>
                          <div className='inner_head'>
                            <button
                              ref={btnDropPopRef}
                              type='button'
                              onClick={(e) => {
                                e.stopPropagation()
                                if (drop === null) {
                                  setDrop(index)
                                } else {
                                  setDrop(null)
                                }
                              }}
                            >
                              <i></i>
                              <i></i>
                              <i></i>
                            </button>
                          </div>
                          {drop !== null && drop === index ? (
                            <EditDropPop ref={editDropPopRef}>
                              <div className='pop_inner'>
                                <button
                                  type='button'
                                  onClick={() => {
                                    const qnaProduct = {
                                      productNo: el.productNo,
                                      productName: el.productName,
                                      brandName: el.brandName,
                                      imgSrc: el.imageUrl,
                                      prevContent: el.content,
                                      modify: true,
                                      inquiryNo: el.inquiryNo,
                                    }

                                    if (isAppView) {
                                      RNPostMessage(AFWebLinkType.moveToLink, {
                                        url: `aboutfishing://aboutfishing.com/?page=webview&url=${
                                          process.env.REACT_APP_SHOP_URL
                                        }/productQnaWrite?qnaProduct=${JSON.stringify(qnaProduct)}`,
                                      })
                                    } else {
                                      navigate(`/productQnaWrite`, {
                                        state: qnaProduct,
                                      })
                                    }
                                  }}
                                >
                                  수정하기
                                </button>
                                <button
                                  type='button'
                                  onClick={() => {
                                    if (window.confirm('삭제하시겠습니까?')) {
                                      delProductQna({
                                        inquiryNo: el.inquiryNo,
                                      }).then(() => {
                                        setDrop(null)
                                        fetchData()
                                      })
                                    } else {
                                      return
                                    }
                                  }}
                                >
                                  삭제하기
                                </button>
                              </div>
                            </EditDropPop>
                          ) : null}
                        </div>
                        <div className='q_tit'>
                          <p>{el.content}</p>
                        </div>
                      </div>
                      {el.answers?.length > 0 && (
                        <div className='a_box'>
                          <div className='a_tit'>
                            <p>{el.answers[0]?.content}</p>
                            <span>
                              {((): any => {
                                const date = new Date(el.answers[0]?.registerYmdt)
                                return format(date, 'yyyy. M. d')
                              })()}
                            </span>
                          </div>
                        </div>
                      )}
                      <div className='img_box'>
                        <div className='inner'>
                          <div className='dim'></div>
                          <img src={el.imageUrl} alt='' />
                          <div>
                            <strong>{el.brandName}</strong>
                            <p>{el.productName}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </QnaList>
                ))}
              </>
            ) : (
              // 목록 없을 때
              <div className='qna_list'>
                <div className='no_data'>
                  <img src={`${imgURL}/empty_logo.png`} alt='' />
                  <p>상품 Q&A 내역이 없습니다.</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export const EditDropPop = styled.div`
  position: absolute;
  top: 20px;
  right: 0;
  z-index: 1;
  & .pop_inner {
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    box-shadow: 1px 1px 12px 0px rgba(41, 41, 41, 0.1);
    background: var(--colWhite);
    & button {
      position: relative;
      font-size: 14px;
      line-height: 18px;
      color: var(--colBlack);
      padding: 12px 0 12px 20px;
      border: 0;
      background: transparent;
      margin: 0;
      &:nth-child(1) {
        border-bottom: 1px var(--colGray3) solid;
      }
      &:nth-child(1)::before {
        content: '';
        width: 16px;
        height: 16px;
        position: absolute;
        top: 12px;
        left: 0;
        background: url('../../images/icon_edit.png') no-repeat;
        background-size: contain;
      }
      &:nth-child(2)::before {
        content: '';
        width: 16px;
        height: 16px;
        position: absolute;
        top: 12px;
        left: 0;
        background: url('../../images/icon_delete2.svg') no-repeat;
        background-size: contain;
      }
    }
  }
`

export const QnaList = styled.div`
  & .qna_item {
    border-bottom: 8px solid var(--colGray1);
    & .q_box {
      padding: 20px 20px 16px;
      & .head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        & .inner_head {
          display: flex;
          gap: 8px;
          align-items: center;
          & span {
            font-size: 14px;
            line-height: 20px;
            color: var(--colPointBlue);
            font-weight: 600;
            word-break: keep-all;
          }
          & i {
            width: 1px;
            height: 12px;
            background: var(--colGray3);
          }
          & em {
            font-style: normal;
            font-size: 14px;
            line-height: 20px;
            color: var(--colGray6);
          }

          & button {
            padding: 0;
            margin: 0;
            border: 0;
            background: transparent;
            display: flex;
            gap: 2px;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            & i {
              width: 3px;
              height: 3px;
              border-radius: 50%;
              background: var(--colBlack);
            }
          }
        }
      }
      & .q_tit {
        margin-top: 8px;
        & p {
          font-size: 16px;
          line-height: 24px;
          position: relative;
          padding-left: 30px;
          word-break: keep-all;
          &:before {
            content: 'Q';
            color: var(--colBlack);
            font-size: 14px;
            line-height: 22px;
            position: absolute;
            top: 0;
            left: 0;
            width: 24px;
            height: 24px;
            border: 1px solid var(--colGray3);
            border-radius: 50%;
            display: inline-block;
            text-align: center;
            box-sizing: border-box;
          }
        }
      }
    }

    & .a_box {
      & .a_tit {
        padding: 18px 20px;
        background: #f3faff;
        & p {
          font-size: 16px;
          line-height: 24px;
          position: relative;
          padding-left: 30px;
          word-break: keep-all;
          &:before {
            content: 'A';
            color: var(--colPointBlue);
            font-size: 14px;
            line-height: 24px;
            position: absolute;
            top: 0;
            left: 0;
            width: 24px;
            height: 24px;
            background: #e3f3ff;
            border-radius: 50%;
            display: inline-block;
            text-align: center;
            box-sizing: border-box;
          }
        }
        & span {
          display: block;
          padding-left: 30px;
          margin-top: 8px;
          font-size: 14px;
          line-height: 20px;
          color: #738599;
        }
      }
    }

    & .img_box {
      border-top: 1px solid var(--colGray3);
      margin: 0 20px;
      & .inner {
        padding: 18px 0 22px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 12px;
        & img {
          width: 56px;
          height: 56px;
          border-radius: 8px;
        }
        & div {
          & strong {
            display: block;
            font-size: 12px;
            line-height: 14px;
            color: var(--colBlack);
            margin-bottom: 2px;
            word-break: keep-all;
          }
          & p {
            font-size: 14px;
            line-height: 18px;
            color: var(--colBlack);
            word-break: keep-all;
          }
        }
      }
    }
  }
  & .complete {
    & .q_box {
      & .head {
        & div {
          & span {
            color: var(--colBlack);
          }
        }
      }
    }
    & .img_box {
      border: 0;
    }
  }
  @media screen and (min-width: 768px) {
    padding: 48px 0 0 0;
    &:first-of-type {
      padding: 32px 0 0 0;
    }
    & .qna_item {
      border-bottom: none;
      & .q_box {
        padding: 0;
        & .head {
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: relative;
          & .inner_head {
            display: flex;
            gap: 8px;
            align-items: center;
            & span {
              font-size: 14px;
              line-height: 20px;
              color: var(--colPointBlue);
              font-weight: 600;
              word-break: keep-all;
            }
            & i {
              width: 1px;
              height: 12px;
              background: var(--colGray3);
            }
            & em {
              font-style: normal;
              font-size: 14px;
              font-weight: 400;
              line-height: 18px;
              color: var(--colGray6);
            }

            & button {
              padding: 0;
              margin: 0;
              border: 0;
              background: transparent;
              display: flex;
              gap: 2px;
              align-items: center;
              justify-content: center;
              width: 20px;
              height: 20px;
              & i {
                width: 3px;
                height: 3px;
                border-radius: 50%;
                background: var(--colBlack);
              }
            }
          }
        }
        & .q_tit {
          margin-top: 8px;
          padding-bottom: 24px;
          & p {
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            color: var(--colBlack);
            position: relative;
            padding-left: 32px;
            word-break: keep-all;
            &:before {
              content: 'Q';
              color: var(--colBlack);
              font-size: 14px;
              line-height: 22px;
              position: absolute;
              top: 0;
              left: 0;
              width: 24px;
              height: 24px;
              border: 1px solid var(--colGray3);
              border-radius: 50%;
              display: inline-block;
              text-align: center;
              box-sizing: border-box;
            }
          }
        }
      }
      & .img_box {
        border-top: 1px solid var(--colGray3);
        border-bottom: 1px solid var(--colGray3);
        margin: 0;
        & .inner {
          position: relative;
          padding: 24px 0;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          gap: 20px;
          & .dim {
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            background-color: var(--colBlack);
            opacity: 0.06;
            width: 56px;
            height: 56px;
            border-radius: 8px;
          }
          & img {
            width: 56px;
            height: 56px;
            border-radius: 8px;
          }
          & div {
            & strong {
              display: block;
              font-size: 14px;
              font-weight: 700;
              line-height: 20px;
              color: var(--colBlack);
              margin-bottom: 4px;
              word-break: keep-all;
            }
            & p {
              font-size: 16px;
              font-weight: 500;
              line-height: 20px;
              color: var(--colBlack);
              word-break: keep-all;
            }
          }
        }
      }
    }
  }
`
